/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  sky_10: '#e1f3fc',
  sky_20: '#c0e5fc',
  sky_30: '#9fd9fc',
  sky_40: '#79c7f7',
  sky_50: '#51b3f0',
  sky_60: '#2f9fe0',
  sky_70: '#1b8bcc',
  sky_80: '#0f75b0',
  sky_90: '#0a6091',
  sky_100: '#084d75',

  a11y_text_light: [80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/sky.js